module.exports = __webpack_public_path__ + "static/img/page_sanzi.777c610.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page_sanzi.png
// module id = 0eIj
// module chunks = 0